import ListEgresos from './List'

const EgresosPage = () => {
  return (
    <>
      <ListEgresos />
    </>
  )
}

export default EgresosPage
